module.exports = __webpack_public_path__ + "img/Trail_Of_Crumbs-2.b430ccb9.gif";